var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-cascader',{attrs:{"options":_vm.options,"load-data":_vm.loadData,"loading":_vm.loading,"placeholder":"请选择地区","disabled":_vm.disabled,"fieldNames":{ label: 'areaName', value: 'areaCode', children: 'children' },"default-value":_vm.checked,"size":_vm.size},on:{"change":_vm.onChange}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4872812e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/comm/components/public/AreaChoice.vue
// module id = null
// module chunks = 